<template>
  <el-container>
    <el-container class="application-container" v-loading="loading">
      <el-header>
        <el-menu
          :default-active="$route.path"
          :router="true"
          background-color="#545C64"
          text-color="#fff"
          active-text-color="#ffd04b"
          mode="horizontal"
        >
          <el-menu-item index="/imobiliarias">
            <i class="el-icon-user-solid"></i>
            <span>Imobiliárias</span>
          </el-menu-item>

          <el-submenu index="grupo-cadastro">
            <template slot="title">
              <i class="menu-icon">
                <font-awesome-icon icon="cog" />
              </i>
              <span>Cadastros Básicos</span>
            </template>
            <el-menu-item index="/cadastro/imobiliaria">
              <span>Imobiliárias</span>
            </el-menu-item>
            <el-menu-item index="/cadastro/bairro">
              <span>Bairros</span>
            </el-menu-item>
            <el-menu-item index="/cadastro/cidade">
              <span>Cidades</span>
            </el-menu-item>
            <el-submenu index="/grupo-caracteristicas">
              <template slot="title">
                Caracteristicas
              </template>
              <el-menu-item index="/caracteristicas/condominio">
                <span>Condomínio</span>
              </el-menu-item>
              <el-menu-item index="/caracteristicas/imovel">
                <span>Imóvel</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/cadastro/construtora">
              <span>Construtoras</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item index="/" @click="logoutSistema()">
            <i class="menu-icon">
              <font-awesome-icon icon="sign-out-alt" />
            </i>
            <span>Sair</span>
          </el-menu-item>
        </el-menu>

        <div style="position: absolute; top: 22px; right: 0px; color: #FFFFFF; padding-right: 20px; font-size: 14px; font-weight: bold;">
          {{ usuarioLogado.nome }}
        </div>
      </el-header>

      <el-main class="application-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      loading: state => state.loading,
    }),
    ...mapState("loginStore", {
      usuarioLogado(state) {
        return state.usuarioLogado;
      },
    }),
  },
  methods: {
    ...mapActions("loginStore", [
      "logout",
    ]),

    logoutSistema() {
      this.logout().then(() => {
        this.$router.go();
      });
    },
  }
};
</script>

<style>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  padding: 0px;
}

.application-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 100vh !important;
}

.application-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  padding: 0px;

  position: absolute;
  top: 60px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}

.menu-icon {
  width: 10px;
  margin-right: 8px;
  font-size: 17px;
}

.application-container .el-loading-mask {
  z-index: 100000;
}

.el-menu--popup {
  border-radius: 0px;
  padding: 0px;
}

.el-menu--popup-right-start {
  margin: 0px;
}

.el-menu--popup-bottom-start {
  margin-top: 0px;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}
</style>
